import { render, staticRenderFns } from "./CreateOrganism.vue?vue&type=template&id=0bffb34d&scoped=true"
import script from "./CreateOrganism.vue?vue&type=script&lang=js"
export * from "./CreateOrganism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffb34d",
  null
  
)

export default component.exports